import { useRecoilValue, useSetRecoilState } from "recoil";
import { onBehalfOfAtom } from "./atom";

export function useOnBehalfOfValue() {
	const value = useRecoilValue(onBehalfOfAtom);
	return value;
}

export function useSetOnBehalfOf() {
	const setter = useSetRecoilState(onBehalfOfAtom);
	return setter;
}
